import React, { useState } from "react";
import { withRouter } from "react-router-dom";

import * as Yup from "yup";
import { Formik, Field } from "formik";

import AuthenticationAPI from "../../api/AuthenticationAPI";

import Alert from "@material-ui/lab/Alert";
import Button from "../../components/Button";
import { textField } from "../../components/Form";
import Separator from "../../components/Separator";

import WaitValidatidateAuth from "./loadingValidateAuth";

import "./index.css";

const VerifyAccount = ({ history, location }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState("");
    const [codeResent, setCodeResent] = useState(false);

    const params = new URLSearchParams(location.search);
    const email = params.get("email");
    const code = params.get("code");

    const VerifyValidation = Yup.object({
        code: Yup.string().required("Code is required")
    });

    const onVerifyAccount = values => {
        setIsLoading(true);

        let payload = {
            code: values.code,
            email
        };

        AuthenticationAPI.verify(payload)
            .then(res => {
                localStorage.setItem("access_token", res.data.accessToken);

                history.push("/dashboard");
            })
            .catch(err => {
                setIsError(err.response.data.message);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleResendCode = () => {
        setIsLoading(true);
        setIsError("");

        const request = {
            email
        };

        AuthenticationAPI.resendCode(request)
            .then(() => {
                setCodeResent(true);
            })
            .catch(err => {
                setIsError(err.response.data.message);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    if (isLoading) return <WaitValidatidateAuth />;

    return (
        <div className="page-container">
            <div className="body-content ">
                <div className="container-reset-password">
                    <div className="wrap-reset-password">
                        <span className="reset-password-title">
                            Verify Account
                        </span>
                        {isError && (
                            <Alert severity="error">
                                {isError}
                            </Alert>
                        )}

                        {codeResent && (
                            <Alert severity="success">
                                {"Code resent successfully. Please check your email"}
                            </Alert>
                        )}
                        <Separator variant="vertical" />

                        <Formik
                            initialValues={{
                                code: code || ""
                            }}
                            enableReinitialize
                            validationSchema={VerifyValidation}
                            onSubmit={onVerifyAccount}
                        >
                            {props => (
                                <>
                                    <div>
                                        <Field
                                            name="code"
                                            placeholder="Code"
                                            disabled={isLoading}
                                            component={textField}
                                        />
                                    </div>

                                    <div
                                        style={{
                                            display: "flex",
                                            marginTop: "12px",
                                            fontSize: "12px"
                                        }}
                                    >
                                        <span>Code Expired?</span>
                                        <span
                                            style={{
                                                marginLeft: "4px",
                                                color: "#343BF5",
                                                fontWeight: "bold",
                                                cursor: "pointer"
                                            }}
                                            onClick={handleResendCode}
                                        >
                                            Click here
                                        </span>
                                    </div>
                                    <Separator variant="vertical" size={20} />

                                    <div
                                        style={{
                                            display: "flex",
                                            // flexDirection: "row",
                                            justifyContent: "space-between"
                                        }}
                                    >
                                        <div>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                disabled={isLoading}
                                                style={{
                                                    padding: "0 20px",
                                                    color: "#fff",
                                                    fontSize: "15px",
                                                    lineHeight: "1.2",
                                                    fontFamily: "Poppins",
                                                    height: "40px"
                                                }}
                                                onClick={props.handleSubmit}
                                            >
                                                Submit
                                            </Button>
                                        </div>
                                    </div>
                                </>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withRouter(VerifyAccount);